/**
 * @ComponentFor Avensia.Shop.Features.Cms.Blocks.LinkBanner.LinkBannerBlockViewModel
 */
import React from "react";
import classnames from "classnames";
import Button from "Shared/Button";
import { epiPropertyValue, EpiProperty } from "@avensia/nitro5-scope-episerver";
import * as styles from "./base.scss";
export default class LinkBannerBlock extends React.Component {
    render() {
        var _a;
        const linkButtonStyle = this.props.targetLink
            .linkButtonStyle;
        const bgImageUrl = ((_a = epiPropertyValue(this.props.block.backgroundImage)) === null || _a === void 0 ? void 0 : _a.url) + "?quality=70";
        return (React.createElement("div", { className: classnames(styles.base, styles[epiPropertyValue(this.props.block.backgroundStyle)]), style: epiPropertyValue(this.props.block.backgroundImage) && {
                backgroundImage: "url(" + bgImageUrl + ")",
            } },
            React.createElement("div", { className: styles.align },
                React.createElement(EpiProperty, { for: this.props.block.header, component: "h2", className: classnames(styles[epiPropertyValue(this.props.block.textColor)]) }),
                React.createElement(EpiProperty, { for: this.props.block.body, className: classnames(styles.preamble, styles[epiPropertyValue(this.props.block.textColor)]) }),
                React.createElement(Button, { appearance: ["large", linkButtonStyle], href: this.props.targetLink.url, target: this.props.targetLink.openInNewWindow ? "_blank" : "" }, this.props.targetLink.text))));
    }
}
